import { LawTerm } from "@/models/law-term/LawTerm";
import { crudService, CrudServiceType } from "./crudService";
import { RestClient } from "./restClient";
import RequestMethod from "@/models/client/RequestMethod";
import RestResponse from "@/models/client/RestResponse";

export type LawTermServiceType = CrudServiceType<LawTerm> & {
  getLawTermByLetter: (
    letter: string,
    search?: string
  ) => RestResponse<LawTerm[]>;
  getAllLawTerms: () => RestResponse<LawTerm[]>;
};

const lawTermServices = (
  client: RestClient,
  path: string
): LawTermServiceType => ({
  ...crudService<LawTerm>(client, path),
  getLawTermByLetter: async (letter: string, search?: string) => {
    const response = await client.fetch<LawTerm[]>(
      RequestMethod.GET,
      `${path}/${letter}?searchTerm=${search}`
    );
    return response;
  },
  getAllLawTerms: async () => {
    const response = await client.fetch<LawTerm[]>(
      RequestMethod.GET,
      `${path}`
    );
    return response;
  },
});

export default lawTermServices;
